var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"divide-gray-400 divide-y"},_vm._l((_vm.docsList),function(block){return _c('div',{key:block.name},[_c('molecule-docs-list',{attrs:{"list":block}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }